// extracted by mini-css-extract-plugin
export default {"editable":"H3_editable__GWngv","notEditable":"H3_notEditable__XtggR"};